import { fetchJSON } from 'omni-ui';

const isLocalDev = !!document.body.querySelector(
  'campaign-test-wrapper,omni-app-container',
);

export default class OmniAPI {
  constructor(env = 'prod') {
    // When campaign is running in portal/omni, we can simply hit the backend with
    // the current location.origin. If running locally for testing we need to
    // fetch from the appropriate omni server.
    let prefix = env;
    if (env === 'local') prefix = 'dev';
    if (env === 'prod') prefix = '';

    this.origin = isLocalDev
      ? `https://${prefix}omni.annalect.com`
      : document.location.origin;

    this.cache = {};
  }

  getClientUsers(clientId) {
    let url = `${this.origin}/api/users?role=external%20client%20-%20viewer&clientId=${clientId}`;
    if (isLocalDev) url += `&ANsid=${window.AN.sso.session.sid}`;
    return fetchJSON(url);
  }

  async getUser(userId, field) {
    let userInfo;
    if (userId === window.AN.sso.user.personId) {
      userInfo = {
        name: window.AN.sso.user.fullName,
        email: window.AN.sso.user.email,
        personId: window.AN.sso.user.personId,
      };
    } else {
      // Use fetch directly since we don't need to send bearer header AND omni (in qa+)
      // breaks with headers sent by fetchJSON().
      const { sid } = window.AN.sso.session;
      const path = `ssoapiexec?func=user/${sid}/${userId}&verb=get`;
      const url = `${this.origin}/${path}`;

      try {
        // Cache fetch promise based on url. Cache the promise to make sure we don't
        // trigger multiple fetch requests for the same user in the interval before we
        // get a response. If we only cache the response data, then a call to this
        // function before the response comes back could cause us to initiate a
        // duplicate request for the same user.
        if (!this.cache[url]) {
          this.cache[url] = fetch(url).then(response => response.json());
        }
        const user = await this.cache[url];
        [userInfo] = user.result;
      } catch (e) {
        console.error(e); // eslint-disable-line no-console
        return userId;
      }
    }

    return field ? userInfo[field] : userInfo;
  }
}
